import { render, staticRenderFns } from "./Cn-COA-Liquid.vue?vue&type=template&id=667859d8&scoped=true&"
import script from "./Cn-COA-Liquid.vue?vue&type=script&lang=js&"
export * from "./Cn-COA-Liquid.vue?vue&type=script&lang=js&"
import style0 from "./Cn-COA-Liquid.vue?vue&type=style&index=0&id=667859d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667859d8",
  null
  
)

export default component.exports